import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./screens/Layout";
import Home from "./screens/Home";
import Sick from "./screens/Sick";
import Late from "./screens/Late";
import More from "./screens/More";
import MoreProfile from "./screens/MoreProfile";
import MoreBirthdays from "./screens/MoreBirthdays";
import MoreGathering from "./screens/MoreGathering";
import MoreContributions from "./screens/MoreContributions";
import MoreHistory from "./screens/MoreHistory";
import Contacts from "./screens/Contacts";
import Login from "./screens/Login";
import NoPage from "./screens/NoPage";
import "./App.css";
import SignIn from "./screens/SignIn";
import SignUp from "./screens/SignUp";
import AdminLayout from "./screens/AdminLayout";
import AdminHome from "./screens/AdminHome";
import AdminLate from "./screens/AdminLate";
import AdminContacts from "./screens/AdminContacts";
import AdminMore from "./screens/AdminMore";
import AdminNoPage from "./screens/AdminNoPage";
import AdminSick from "./screens/AdminSick";
import MemberBirthday from "./screens/MemberBirthday";
import MemberGathering from "./screens/MemberGathering";
import MemberContributions from "./screens/MemberContributions";
import MemberHistory from "./screens/MemberHistory";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="" element={<Login />}>
          <Route index element={<Login />} />
        </Route>
        <Route path="/signin" element={<SignIn />}>
          <Route index element={<SignIn />} />
        </Route>
        <Route path="/signup" element={<SignUp />}>
          <Route index element={<SignUp />} />
        </Route>
        <Route path="/app" element={<Layout />}>
          <Route index element={<Layout />} />
          <Route path="home" element={<Home />} />
          <Route path="Sick" element={<Sick />} />
          <Route path="late" element={<Late />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="more" element={<More />} />
          <Route path="birthdays" element={<MemberBirthday />} />
          <Route path="gatherings" element={<MemberGathering />} />
          <Route path="contributions" element={<MemberContributions />} />
          <Route path="history" element={<MemberHistory />} />
          <Route path="*" element={<NoPage />} />
        </Route>
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminHome />} />
          <Route path="home" element={<AdminHome />} />
          <Route path="Sick" element={<AdminSick />} />
          <Route path="late" element={<AdminLate />} />
          <Route path="contacts" element={<AdminContacts />} />
          <Route path="more" element={<AdminMore />} />
          <Route path="profile" element={<MoreProfile />} />
          <Route path="birthdays" element={<MoreBirthdays />} />
          <Route path="gatherings" element={<MoreGathering />} />
          <Route path="contributions" element={<MoreContributions />} />
          <Route path="history" element={<MoreHistory />} />
          <Route path="*" element={<AdminNoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
